<template>
  <layout>
    <h4>Create term</h4>
    <resource-form
      @saved="returnBack"
      @cancelled="$router.go(-1)"
    />
  </layout>
</template>

<script>
import Layout from '../layouts/Default.vue';
import ResourceForm from './Form.vue';

const resourceBase = 'terms';

export default {
  name: 'TermsCreate',

  components: {
    Layout,
    ResourceForm,
  },

  methods: {
    returnBack(result) {
      this.$router.push({
        name: `${resourceBase}.index`,
        params: { taxonomy: result.data.taxonomy },
      });
    },
  },

};
</script>
